// extracted by mini-css-extract-plugin
export default {"container":"GapSuggestion_container__AONS+","title":"GapSuggestion_title__4ebDJ","link":"GapSuggestion_link__-qpxI"};